/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ZeiterfassungRouteImport } from './routes/zeiterfassung'
import { Route as VertraegeRouteImport } from './routes/vertraege'
import { Route as UsersRouteImport } from './routes/users'
import { Route as SerienleistungenRouteImport } from './routes/serienleistungen'
import { Route as ReklamationenRouteImport } from './routes/reklamationen'
import { Route as RechnungenRouteImport } from './routes/rechnungen'
import { Route as ProjekteRouteImport } from './routes/projekte'
import { Route as ObjekteRouteImport } from './routes/objekte'
import { Route as MitarbeiterRouteImport } from './routes/mitarbeiter'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KundenRouteImport } from './routes/kunden'
import { Route as KontrollgaengeRouteImport } from './routes/kontrollgaenge'
import { Route as KontakteRouteImport } from './routes/kontakte'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as FinanzenRouteImport } from './routes/finanzen'
import { Route as AuftraegeRouteImport } from './routes/auftraege'
import { Route as ArtikelRouteImport } from './routes/artikel'
import { Route as AngeboteRouteImport } from './routes/angebote'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ZeiterfassungIndexRouteImport } from './routes/zeiterfassung.index'
import { Route as VertraegeIndexRouteImport } from './routes/vertraege.index'
import { Route as SubunternehmerIndexRouteImport } from './routes/subunternehmer.index'
import { Route as SerienleistungenIndexRouteImport } from './routes/serienleistungen.index'
import { Route as ReklamationenIndexRouteImport } from './routes/reklamationen.index'
import { Route as RechnungenIndexRouteImport } from './routes/rechnungen.index'
import { Route as ProjekteIndexRouteImport } from './routes/projekte.index'
import { Route as PortalUsersIndexRouteImport } from './routes/portal-users.index'
import { Route as ObjekteIndexRouteImport } from './routes/objekte.index'
import { Route as MitarbeiterIndexRouteImport } from './routes/mitarbeiter.index'
import { Route as KundenIndexRouteImport } from './routes/kunden.index'
import { Route as KontrollgaengeIndexRouteImport } from './routes/kontrollgaenge.index'
import { Route as InboxIndexRouteImport } from './routes/inbox.index'
import { Route as BautagebuchIndexRouteImport } from './routes/bautagebuch.index'
import { Route as AuftraegeIndexRouteImport } from './routes/auftraege.index'
import { Route as ArtikelIndexRouteImport } from './routes/artikel.index'
import { Route as AngeboteIndexRouteImport } from './routes/angebote.index'
import { Route as ZeiterfassungMonatRouteImport } from './routes/zeiterfassung.monat'
import { Route as ZeiterfassungAntragRouteImport } from './routes/zeiterfassung.antrag'
import { Route as ZeiterfassungAdminRouteImport } from './routes/zeiterfassung.admin'
import { Route as VertraegeNeuRouteImport } from './routes/vertraege.neu'
import { Route as VertraegeMahnungenRouteImport } from './routes/vertraege.mahnungen'
import { Route as SerienleistungenNeuRouteImport } from './routes/serienleistungen.neu'
import { Route as SerienleistungenIdRouteImport } from './routes/serienleistungen.$id'
import { Route as ReklamationenNeuRouteImport } from './routes/reklamationen.neu'
import { Route as ReklamationenIdRouteImport } from './routes/reklamationen.$id'
import { Route as RechnungenNeuRouteImport } from './routes/rechnungen.neu'
import { Route as RechnungenIdRouteImport } from './routes/rechnungen.$id'
import { Route as ProjekteNeuRouteImport } from './routes/projekte.neu'
import { Route as ProjekteIdRouteImport } from './routes/projekte.$id'
import { Route as PortalUsersIdRouteImport } from './routes/portal-users.$id'
import { Route as ObjekteIdRouteImport } from './routes/objekte.$id'
import { Route as MitarbeiterIdRouteImport } from './routes/mitarbeiter.$id'
import { Route as KundenNeuRouteImport } from './routes/kunden.neu'
import { Route as KundenIdRouteImport } from './routes/kunden.$id'
import { Route as KontrollgaengeNeuRouteImport } from './routes/kontrollgaenge.neu'
import { Route as KontrollgaengeIdRouteImport } from './routes/kontrollgaenge.$id'
import { Route as InboxNeuRouteImport } from './routes/inbox.neu'
import { Route as InboxIdRouteImport } from './routes/inbox.$id'
import { Route as FinanzenEingangsrechnungenRouteImport } from './routes/finanzen.eingangsrechnungen'
import { Route as FinanzenBankRouteImport } from './routes/finanzen.bank'
import { Route as AuftraegeOffeneEntscheidungenRouteImport } from './routes/auftraege.offene-entscheidungen'
import { Route as AuftraegeNeuRouteImport } from './routes/auftraege.neu'
import { Route as AuftraegeIdRouteImport } from './routes/auftraege.$id'
import { Route as ArtikelIdRouteImport } from './routes/artikel.$id'
import { Route as AngeboteNeuRouteImport } from './routes/angebote.neu'
import { Route as AngeboteIdRouteImport } from './routes/angebote.$id'
import { Route as VertraegeNeuVorlagenRouteImport } from './routes/vertraege.neu_.vorlagen'
import { Route as VertraegeEntwurfIdRouteImport } from './routes/vertraege.entwurf.$id'
import { Route as VertraegeBvIdRouteImport } from './routes/vertraege.bv.$id'

const ZeiterfassungRoute = ZeiterfassungRouteImport.update({
  id: '/zeiterfassung',
  path: '/zeiterfassung',
  getParentRoute: () => rootRouteImport,
} as any)
const VertraegeRoute = VertraegeRouteImport.update({
  id: '/vertraege',
  path: '/vertraege',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const SerienleistungenRoute = SerienleistungenRouteImport.update({
  id: '/serienleistungen',
  path: '/serienleistungen',
  getParentRoute: () => rootRouteImport,
} as any)
const ReklamationenRoute = ReklamationenRouteImport.update({
  id: '/reklamationen',
  path: '/reklamationen',
  getParentRoute: () => rootRouteImport,
} as any)
const RechnungenRoute = RechnungenRouteImport.update({
  id: '/rechnungen',
  path: '/rechnungen',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjekteRoute = ProjekteRouteImport.update({
  id: '/projekte',
  path: '/projekte',
  getParentRoute: () => rootRouteImport,
} as any)
const ObjekteRoute = ObjekteRouteImport.update({
  id: '/objekte',
  path: '/objekte',
  getParentRoute: () => rootRouteImport,
} as any)
const MitarbeiterRoute = MitarbeiterRouteImport.update({
  id: '/mitarbeiter',
  path: '/mitarbeiter',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const KundenRoute = KundenRouteImport.update({
  id: '/kunden',
  path: '/kunden',
  getParentRoute: () => rootRouteImport,
} as any)
const KontrollgaengeRoute = KontrollgaengeRouteImport.update({
  id: '/kontrollgaenge',
  path: '/kontrollgaenge',
  getParentRoute: () => rootRouteImport,
} as any)
const KontakteRoute = KontakteRouteImport.update({
  id: '/kontakte',
  path: '/kontakte',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanzenRoute = FinanzenRouteImport.update({
  id: '/finanzen',
  path: '/finanzen',
  getParentRoute: () => rootRouteImport,
} as any)
const AuftraegeRoute = AuftraegeRouteImport.update({
  id: '/auftraege',
  path: '/auftraege',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtikelRoute = ArtikelRouteImport.update({
  id: '/artikel',
  path: '/artikel',
  getParentRoute: () => rootRouteImport,
} as any)
const AngeboteRoute = AngeboteRouteImport.update({
  id: '/angebote',
  path: '/angebote',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ZeiterfassungIndexRoute = ZeiterfassungIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ZeiterfassungRoute,
} as any)
const VertraegeIndexRoute = VertraegeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VertraegeRoute,
} as any)
const SubunternehmerIndexRoute = SubunternehmerIndexRouteImport.update({
  id: '/subunternehmer/',
  path: '/subunternehmer/',
  getParentRoute: () => rootRouteImport,
} as any)
const SerienleistungenIndexRoute = SerienleistungenIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SerienleistungenRoute,
} as any)
const ReklamationenIndexRoute = ReklamationenIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReklamationenRoute,
} as any)
const RechnungenIndexRoute = RechnungenIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RechnungenRoute,
} as any)
const ProjekteIndexRoute = ProjekteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjekteRoute,
} as any)
const PortalUsersIndexRoute = PortalUsersIndexRouteImport.update({
  id: '/portal-users/',
  path: '/portal-users/',
  getParentRoute: () => rootRouteImport,
} as any)
const ObjekteIndexRoute = ObjekteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ObjekteRoute,
} as any)
const MitarbeiterIndexRoute = MitarbeiterIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MitarbeiterRoute,
} as any)
const KundenIndexRoute = KundenIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => KundenRoute,
} as any)
const KontrollgaengeIndexRoute = KontrollgaengeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => KontrollgaengeRoute,
} as any)
const InboxIndexRoute = InboxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InboxRoute,
} as any)
const BautagebuchIndexRoute = BautagebuchIndexRouteImport.update({
  id: '/bautagebuch/',
  path: '/bautagebuch/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuftraegeIndexRoute = AuftraegeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuftraegeRoute,
} as any)
const ArtikelIndexRoute = ArtikelIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ArtikelRoute,
} as any)
const AngeboteIndexRoute = AngeboteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AngeboteRoute,
} as any)
const ZeiterfassungMonatRoute = ZeiterfassungMonatRouteImport.update({
  id: '/monat',
  path: '/monat',
  getParentRoute: () => ZeiterfassungRoute,
} as any)
const ZeiterfassungAntragRoute = ZeiterfassungAntragRouteImport.update({
  id: '/antrag',
  path: '/antrag',
  getParentRoute: () => ZeiterfassungRoute,
} as any)
const ZeiterfassungAdminRoute = ZeiterfassungAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => ZeiterfassungRoute,
} as any)
const VertraegeNeuRoute = VertraegeNeuRouteImport.update({
  id: '/neu',
  path: '/neu',
  getParentRoute: () => VertraegeRoute,
} as any)
const VertraegeMahnungenRoute = VertraegeMahnungenRouteImport.update({
  id: '/mahnungen',
  path: '/mahnungen',
  getParentRoute: () => VertraegeRoute,
} as any)
const SerienleistungenNeuRoute = SerienleistungenNeuRouteImport.update({
  id: '/neu',
  path: '/neu',
  getParentRoute: () => SerienleistungenRoute,
} as any)
const SerienleistungenIdRoute = SerienleistungenIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SerienleistungenRoute,
} as any)
const ReklamationenNeuRoute = ReklamationenNeuRouteImport.update({
  id: '/neu',
  path: '/neu',
  getParentRoute: () => ReklamationenRoute,
} as any)
const ReklamationenIdRoute = ReklamationenIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ReklamationenRoute,
} as any)
const RechnungenNeuRoute = RechnungenNeuRouteImport.update({
  id: '/neu',
  path: '/neu',
  getParentRoute: () => RechnungenRoute,
} as any)
const RechnungenIdRoute = RechnungenIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => RechnungenRoute,
} as any)
const ProjekteNeuRoute = ProjekteNeuRouteImport.update({
  id: '/neu',
  path: '/neu',
  getParentRoute: () => ProjekteRoute,
} as any)
const ProjekteIdRoute = ProjekteIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ProjekteRoute,
} as any)
const PortalUsersIdRoute = PortalUsersIdRouteImport.update({
  id: '/portal-users/$id',
  path: '/portal-users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ObjekteIdRoute = ObjekteIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ObjekteRoute,
} as any)
const MitarbeiterIdRoute = MitarbeiterIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => MitarbeiterRoute,
} as any)
const KundenNeuRoute = KundenNeuRouteImport.update({
  id: '/neu',
  path: '/neu',
  getParentRoute: () => KundenRoute,
} as any)
const KundenIdRoute = KundenIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => KundenRoute,
} as any)
const KontrollgaengeNeuRoute = KontrollgaengeNeuRouteImport.update({
  id: '/neu',
  path: '/neu',
  getParentRoute: () => KontrollgaengeRoute,
} as any)
const KontrollgaengeIdRoute = KontrollgaengeIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => KontrollgaengeRoute,
} as any)
const InboxNeuRoute = InboxNeuRouteImport.update({
  id: '/neu',
  path: '/neu',
  getParentRoute: () => InboxRoute,
} as any)
const InboxIdRoute = InboxIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => InboxRoute,
} as any)
const FinanzenEingangsrechnungenRoute =
  FinanzenEingangsrechnungenRouteImport.update({
    id: '/eingangsrechnungen',
    path: '/eingangsrechnungen',
    getParentRoute: () => FinanzenRoute,
  } as any)
const FinanzenBankRoute = FinanzenBankRouteImport.update({
  id: '/bank',
  path: '/bank',
  getParentRoute: () => FinanzenRoute,
} as any)
const AuftraegeOffeneEntscheidungenRoute =
  AuftraegeOffeneEntscheidungenRouteImport.update({
    id: '/offene-entscheidungen',
    path: '/offene-entscheidungen',
    getParentRoute: () => AuftraegeRoute,
  } as any)
const AuftraegeNeuRoute = AuftraegeNeuRouteImport.update({
  id: '/neu',
  path: '/neu',
  getParentRoute: () => AuftraegeRoute,
} as any)
const AuftraegeIdRoute = AuftraegeIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuftraegeRoute,
} as any)
const ArtikelIdRoute = ArtikelIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ArtikelRoute,
} as any)
const AngeboteNeuRoute = AngeboteNeuRouteImport.update({
  id: '/neu',
  path: '/neu',
  getParentRoute: () => AngeboteRoute,
} as any)
const AngeboteIdRoute = AngeboteIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AngeboteRoute,
} as any)
const VertraegeNeuVorlagenRoute = VertraegeNeuVorlagenRouteImport.update({
  id: '/neu_/vorlagen',
  path: '/neu/vorlagen',
  getParentRoute: () => VertraegeRoute,
} as any)
const VertraegeEntwurfIdRoute = VertraegeEntwurfIdRouteImport.update({
  id: '/entwurf/$id',
  path: '/entwurf/$id',
  getParentRoute: () => VertraegeRoute,
} as any)
const VertraegeBvIdRoute = VertraegeBvIdRouteImport.update({
  id: '/bv/$id',
  path: '/bv/$id',
  getParentRoute: () => VertraegeRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/angebote': typeof AngeboteRouteWithChildren
  '/artikel': typeof ArtikelRouteWithChildren
  '/auftraege': typeof AuftraegeRouteWithChildren
  '/finanzen': typeof FinanzenRouteWithChildren
  '/inbox': typeof InboxRouteWithChildren
  '/kontakte': typeof KontakteRoute
  '/kontrollgaenge': typeof KontrollgaengeRouteWithChildren
  '/kunden': typeof KundenRouteWithChildren
  '/login': typeof LoginRoute
  '/mitarbeiter': typeof MitarbeiterRouteWithChildren
  '/objekte': typeof ObjekteRouteWithChildren
  '/projekte': typeof ProjekteRouteWithChildren
  '/rechnungen': typeof RechnungenRouteWithChildren
  '/reklamationen': typeof ReklamationenRouteWithChildren
  '/serienleistungen': typeof SerienleistungenRouteWithChildren
  '/users': typeof UsersRoute
  '/vertraege': typeof VertraegeRouteWithChildren
  '/zeiterfassung': typeof ZeiterfassungRouteWithChildren
  '/angebote/$id': typeof AngeboteIdRoute
  '/angebote/neu': typeof AngeboteNeuRoute
  '/artikel/$id': typeof ArtikelIdRoute
  '/auftraege/$id': typeof AuftraegeIdRoute
  '/auftraege/neu': typeof AuftraegeNeuRoute
  '/auftraege/offene-entscheidungen': typeof AuftraegeOffeneEntscheidungenRoute
  '/finanzen/bank': typeof FinanzenBankRoute
  '/finanzen/eingangsrechnungen': typeof FinanzenEingangsrechnungenRoute
  '/inbox/$id': typeof InboxIdRoute
  '/inbox/neu': typeof InboxNeuRoute
  '/kontrollgaenge/$id': typeof KontrollgaengeIdRoute
  '/kontrollgaenge/neu': typeof KontrollgaengeNeuRoute
  '/kunden/$id': typeof KundenIdRoute
  '/kunden/neu': typeof KundenNeuRoute
  '/mitarbeiter/$id': typeof MitarbeiterIdRoute
  '/objekte/$id': typeof ObjekteIdRoute
  '/portal-users/$id': typeof PortalUsersIdRoute
  '/projekte/$id': typeof ProjekteIdRoute
  '/projekte/neu': typeof ProjekteNeuRoute
  '/rechnungen/$id': typeof RechnungenIdRoute
  '/rechnungen/neu': typeof RechnungenNeuRoute
  '/reklamationen/$id': typeof ReklamationenIdRoute
  '/reklamationen/neu': typeof ReklamationenNeuRoute
  '/serienleistungen/$id': typeof SerienleistungenIdRoute
  '/serienleistungen/neu': typeof SerienleistungenNeuRoute
  '/vertraege/mahnungen': typeof VertraegeMahnungenRoute
  '/vertraege/neu': typeof VertraegeNeuRoute
  '/zeiterfassung/admin': typeof ZeiterfassungAdminRoute
  '/zeiterfassung/antrag': typeof ZeiterfassungAntragRoute
  '/zeiterfassung/monat': typeof ZeiterfassungMonatRoute
  '/angebote/': typeof AngeboteIndexRoute
  '/artikel/': typeof ArtikelIndexRoute
  '/auftraege/': typeof AuftraegeIndexRoute
  '/bautagebuch/': typeof BautagebuchIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/kontrollgaenge/': typeof KontrollgaengeIndexRoute
  '/kunden/': typeof KundenIndexRoute
  '/mitarbeiter/': typeof MitarbeiterIndexRoute
  '/objekte/': typeof ObjekteIndexRoute
  '/portal-users/': typeof PortalUsersIndexRoute
  '/projekte/': typeof ProjekteIndexRoute
  '/rechnungen/': typeof RechnungenIndexRoute
  '/reklamationen/': typeof ReklamationenIndexRoute
  '/serienleistungen/': typeof SerienleistungenIndexRoute
  '/subunternehmer/': typeof SubunternehmerIndexRoute
  '/vertraege/': typeof VertraegeIndexRoute
  '/zeiterfassung/': typeof ZeiterfassungIndexRoute
  '/vertraege/bv/$id': typeof VertraegeBvIdRoute
  '/vertraege/entwurf/$id': typeof VertraegeEntwurfIdRoute
  '/vertraege/neu/vorlagen': typeof VertraegeNeuVorlagenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/finanzen': typeof FinanzenRouteWithChildren
  '/kontakte': typeof KontakteRoute
  '/login': typeof LoginRoute
  '/users': typeof UsersRoute
  '/angebote/$id': typeof AngeboteIdRoute
  '/angebote/neu': typeof AngeboteNeuRoute
  '/artikel/$id': typeof ArtikelIdRoute
  '/auftraege/$id': typeof AuftraegeIdRoute
  '/auftraege/neu': typeof AuftraegeNeuRoute
  '/auftraege/offene-entscheidungen': typeof AuftraegeOffeneEntscheidungenRoute
  '/finanzen/bank': typeof FinanzenBankRoute
  '/finanzen/eingangsrechnungen': typeof FinanzenEingangsrechnungenRoute
  '/inbox/$id': typeof InboxIdRoute
  '/inbox/neu': typeof InboxNeuRoute
  '/kontrollgaenge/$id': typeof KontrollgaengeIdRoute
  '/kontrollgaenge/neu': typeof KontrollgaengeNeuRoute
  '/kunden/$id': typeof KundenIdRoute
  '/kunden/neu': typeof KundenNeuRoute
  '/mitarbeiter/$id': typeof MitarbeiterIdRoute
  '/objekte/$id': typeof ObjekteIdRoute
  '/portal-users/$id': typeof PortalUsersIdRoute
  '/projekte/$id': typeof ProjekteIdRoute
  '/projekte/neu': typeof ProjekteNeuRoute
  '/rechnungen/$id': typeof RechnungenIdRoute
  '/rechnungen/neu': typeof RechnungenNeuRoute
  '/reklamationen/$id': typeof ReklamationenIdRoute
  '/reklamationen/neu': typeof ReklamationenNeuRoute
  '/serienleistungen/$id': typeof SerienleistungenIdRoute
  '/serienleistungen/neu': typeof SerienleistungenNeuRoute
  '/vertraege/mahnungen': typeof VertraegeMahnungenRoute
  '/vertraege/neu': typeof VertraegeNeuRoute
  '/zeiterfassung/admin': typeof ZeiterfassungAdminRoute
  '/zeiterfassung/antrag': typeof ZeiterfassungAntragRoute
  '/zeiterfassung/monat': typeof ZeiterfassungMonatRoute
  '/angebote': typeof AngeboteIndexRoute
  '/artikel': typeof ArtikelIndexRoute
  '/auftraege': typeof AuftraegeIndexRoute
  '/bautagebuch': typeof BautagebuchIndexRoute
  '/inbox': typeof InboxIndexRoute
  '/kontrollgaenge': typeof KontrollgaengeIndexRoute
  '/kunden': typeof KundenIndexRoute
  '/mitarbeiter': typeof MitarbeiterIndexRoute
  '/objekte': typeof ObjekteIndexRoute
  '/portal-users': typeof PortalUsersIndexRoute
  '/projekte': typeof ProjekteIndexRoute
  '/rechnungen': typeof RechnungenIndexRoute
  '/reklamationen': typeof ReklamationenIndexRoute
  '/serienleistungen': typeof SerienleistungenIndexRoute
  '/subunternehmer': typeof SubunternehmerIndexRoute
  '/vertraege': typeof VertraegeIndexRoute
  '/zeiterfassung': typeof ZeiterfassungIndexRoute
  '/vertraege/bv/$id': typeof VertraegeBvIdRoute
  '/vertraege/entwurf/$id': typeof VertraegeEntwurfIdRoute
  '/vertraege/neu/vorlagen': typeof VertraegeNeuVorlagenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/angebote': typeof AngeboteRouteWithChildren
  '/artikel': typeof ArtikelRouteWithChildren
  '/auftraege': typeof AuftraegeRouteWithChildren
  '/finanzen': typeof FinanzenRouteWithChildren
  '/inbox': typeof InboxRouteWithChildren
  '/kontakte': typeof KontakteRoute
  '/kontrollgaenge': typeof KontrollgaengeRouteWithChildren
  '/kunden': typeof KundenRouteWithChildren
  '/login': typeof LoginRoute
  '/mitarbeiter': typeof MitarbeiterRouteWithChildren
  '/objekte': typeof ObjekteRouteWithChildren
  '/projekte': typeof ProjekteRouteWithChildren
  '/rechnungen': typeof RechnungenRouteWithChildren
  '/reklamationen': typeof ReklamationenRouteWithChildren
  '/serienleistungen': typeof SerienleistungenRouteWithChildren
  '/users': typeof UsersRoute
  '/vertraege': typeof VertraegeRouteWithChildren
  '/zeiterfassung': typeof ZeiterfassungRouteWithChildren
  '/angebote/$id': typeof AngeboteIdRoute
  '/angebote/neu': typeof AngeboteNeuRoute
  '/artikel/$id': typeof ArtikelIdRoute
  '/auftraege/$id': typeof AuftraegeIdRoute
  '/auftraege/neu': typeof AuftraegeNeuRoute
  '/auftraege/offene-entscheidungen': typeof AuftraegeOffeneEntscheidungenRoute
  '/finanzen/bank': typeof FinanzenBankRoute
  '/finanzen/eingangsrechnungen': typeof FinanzenEingangsrechnungenRoute
  '/inbox/$id': typeof InboxIdRoute
  '/inbox/neu': typeof InboxNeuRoute
  '/kontrollgaenge/$id': typeof KontrollgaengeIdRoute
  '/kontrollgaenge/neu': typeof KontrollgaengeNeuRoute
  '/kunden/$id': typeof KundenIdRoute
  '/kunden/neu': typeof KundenNeuRoute
  '/mitarbeiter/$id': typeof MitarbeiterIdRoute
  '/objekte/$id': typeof ObjekteIdRoute
  '/portal-users/$id': typeof PortalUsersIdRoute
  '/projekte/$id': typeof ProjekteIdRoute
  '/projekte/neu': typeof ProjekteNeuRoute
  '/rechnungen/$id': typeof RechnungenIdRoute
  '/rechnungen/neu': typeof RechnungenNeuRoute
  '/reklamationen/$id': typeof ReklamationenIdRoute
  '/reklamationen/neu': typeof ReklamationenNeuRoute
  '/serienleistungen/$id': typeof SerienleistungenIdRoute
  '/serienleistungen/neu': typeof SerienleistungenNeuRoute
  '/vertraege/mahnungen': typeof VertraegeMahnungenRoute
  '/vertraege/neu': typeof VertraegeNeuRoute
  '/zeiterfassung/admin': typeof ZeiterfassungAdminRoute
  '/zeiterfassung/antrag': typeof ZeiterfassungAntragRoute
  '/zeiterfassung/monat': typeof ZeiterfassungMonatRoute
  '/angebote/': typeof AngeboteIndexRoute
  '/artikel/': typeof ArtikelIndexRoute
  '/auftraege/': typeof AuftraegeIndexRoute
  '/bautagebuch/': typeof BautagebuchIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/kontrollgaenge/': typeof KontrollgaengeIndexRoute
  '/kunden/': typeof KundenIndexRoute
  '/mitarbeiter/': typeof MitarbeiterIndexRoute
  '/objekte/': typeof ObjekteIndexRoute
  '/portal-users/': typeof PortalUsersIndexRoute
  '/projekte/': typeof ProjekteIndexRoute
  '/rechnungen/': typeof RechnungenIndexRoute
  '/reklamationen/': typeof ReklamationenIndexRoute
  '/serienleistungen/': typeof SerienleistungenIndexRoute
  '/subunternehmer/': typeof SubunternehmerIndexRoute
  '/vertraege/': typeof VertraegeIndexRoute
  '/zeiterfassung/': typeof ZeiterfassungIndexRoute
  '/vertraege/bv/$id': typeof VertraegeBvIdRoute
  '/vertraege/entwurf/$id': typeof VertraegeEntwurfIdRoute
  '/vertraege/neu_/vorlagen': typeof VertraegeNeuVorlagenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/angebote'
    | '/artikel'
    | '/auftraege'
    | '/finanzen'
    | '/inbox'
    | '/kontakte'
    | '/kontrollgaenge'
    | '/kunden'
    | '/login'
    | '/mitarbeiter'
    | '/objekte'
    | '/projekte'
    | '/rechnungen'
    | '/reklamationen'
    | '/serienleistungen'
    | '/users'
    | '/vertraege'
    | '/zeiterfassung'
    | '/angebote/$id'
    | '/angebote/neu'
    | '/artikel/$id'
    | '/auftraege/$id'
    | '/auftraege/neu'
    | '/auftraege/offene-entscheidungen'
    | '/finanzen/bank'
    | '/finanzen/eingangsrechnungen'
    | '/inbox/$id'
    | '/inbox/neu'
    | '/kontrollgaenge/$id'
    | '/kontrollgaenge/neu'
    | '/kunden/$id'
    | '/kunden/neu'
    | '/mitarbeiter/$id'
    | '/objekte/$id'
    | '/portal-users/$id'
    | '/projekte/$id'
    | '/projekte/neu'
    | '/rechnungen/$id'
    | '/rechnungen/neu'
    | '/reklamationen/$id'
    | '/reklamationen/neu'
    | '/serienleistungen/$id'
    | '/serienleistungen/neu'
    | '/vertraege/mahnungen'
    | '/vertraege/neu'
    | '/zeiterfassung/admin'
    | '/zeiterfassung/antrag'
    | '/zeiterfassung/monat'
    | '/angebote/'
    | '/artikel/'
    | '/auftraege/'
    | '/bautagebuch/'
    | '/inbox/'
    | '/kontrollgaenge/'
    | '/kunden/'
    | '/mitarbeiter/'
    | '/objekte/'
    | '/portal-users/'
    | '/projekte/'
    | '/rechnungen/'
    | '/reklamationen/'
    | '/serienleistungen/'
    | '/subunternehmer/'
    | '/vertraege/'
    | '/zeiterfassung/'
    | '/vertraege/bv/$id'
    | '/vertraege/entwurf/$id'
    | '/vertraege/neu/vorlagen'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/finanzen'
    | '/kontakte'
    | '/login'
    | '/users'
    | '/angebote/$id'
    | '/angebote/neu'
    | '/artikel/$id'
    | '/auftraege/$id'
    | '/auftraege/neu'
    | '/auftraege/offene-entscheidungen'
    | '/finanzen/bank'
    | '/finanzen/eingangsrechnungen'
    | '/inbox/$id'
    | '/inbox/neu'
    | '/kontrollgaenge/$id'
    | '/kontrollgaenge/neu'
    | '/kunden/$id'
    | '/kunden/neu'
    | '/mitarbeiter/$id'
    | '/objekte/$id'
    | '/portal-users/$id'
    | '/projekte/$id'
    | '/projekte/neu'
    | '/rechnungen/$id'
    | '/rechnungen/neu'
    | '/reklamationen/$id'
    | '/reklamationen/neu'
    | '/serienleistungen/$id'
    | '/serienleistungen/neu'
    | '/vertraege/mahnungen'
    | '/vertraege/neu'
    | '/zeiterfassung/admin'
    | '/zeiterfassung/antrag'
    | '/zeiterfassung/monat'
    | '/angebote'
    | '/artikel'
    | '/auftraege'
    | '/bautagebuch'
    | '/inbox'
    | '/kontrollgaenge'
    | '/kunden'
    | '/mitarbeiter'
    | '/objekte'
    | '/portal-users'
    | '/projekte'
    | '/rechnungen'
    | '/reklamationen'
    | '/serienleistungen'
    | '/subunternehmer'
    | '/vertraege'
    | '/zeiterfassung'
    | '/vertraege/bv/$id'
    | '/vertraege/entwurf/$id'
    | '/vertraege/neu/vorlagen'
  id:
    | '__root__'
    | '/'
    | '/angebote'
    | '/artikel'
    | '/auftraege'
    | '/finanzen'
    | '/inbox'
    | '/kontakte'
    | '/kontrollgaenge'
    | '/kunden'
    | '/login'
    | '/mitarbeiter'
    | '/objekte'
    | '/projekte'
    | '/rechnungen'
    | '/reklamationen'
    | '/serienleistungen'
    | '/users'
    | '/vertraege'
    | '/zeiterfassung'
    | '/angebote/$id'
    | '/angebote/neu'
    | '/artikel/$id'
    | '/auftraege/$id'
    | '/auftraege/neu'
    | '/auftraege/offene-entscheidungen'
    | '/finanzen/bank'
    | '/finanzen/eingangsrechnungen'
    | '/inbox/$id'
    | '/inbox/neu'
    | '/kontrollgaenge/$id'
    | '/kontrollgaenge/neu'
    | '/kunden/$id'
    | '/kunden/neu'
    | '/mitarbeiter/$id'
    | '/objekte/$id'
    | '/portal-users/$id'
    | '/projekte/$id'
    | '/projekte/neu'
    | '/rechnungen/$id'
    | '/rechnungen/neu'
    | '/reklamationen/$id'
    | '/reklamationen/neu'
    | '/serienleistungen/$id'
    | '/serienleistungen/neu'
    | '/vertraege/mahnungen'
    | '/vertraege/neu'
    | '/zeiterfassung/admin'
    | '/zeiterfassung/antrag'
    | '/zeiterfassung/monat'
    | '/angebote/'
    | '/artikel/'
    | '/auftraege/'
    | '/bautagebuch/'
    | '/inbox/'
    | '/kontrollgaenge/'
    | '/kunden/'
    | '/mitarbeiter/'
    | '/objekte/'
    | '/portal-users/'
    | '/projekte/'
    | '/rechnungen/'
    | '/reklamationen/'
    | '/serienleistungen/'
    | '/subunternehmer/'
    | '/vertraege/'
    | '/zeiterfassung/'
    | '/vertraege/bv/$id'
    | '/vertraege/entwurf/$id'
    | '/vertraege/neu_/vorlagen'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AngeboteRoute: typeof AngeboteRouteWithChildren
  ArtikelRoute: typeof ArtikelRouteWithChildren
  AuftraegeRoute: typeof AuftraegeRouteWithChildren
  FinanzenRoute: typeof FinanzenRouteWithChildren
  InboxRoute: typeof InboxRouteWithChildren
  KontakteRoute: typeof KontakteRoute
  KontrollgaengeRoute: typeof KontrollgaengeRouteWithChildren
  KundenRoute: typeof KundenRouteWithChildren
  LoginRoute: typeof LoginRoute
  MitarbeiterRoute: typeof MitarbeiterRouteWithChildren
  ObjekteRoute: typeof ObjekteRouteWithChildren
  ProjekteRoute: typeof ProjekteRouteWithChildren
  RechnungenRoute: typeof RechnungenRouteWithChildren
  ReklamationenRoute: typeof ReklamationenRouteWithChildren
  SerienleistungenRoute: typeof SerienleistungenRouteWithChildren
  UsersRoute: typeof UsersRoute
  VertraegeRoute: typeof VertraegeRouteWithChildren
  ZeiterfassungRoute: typeof ZeiterfassungRouteWithChildren
  PortalUsersIdRoute: typeof PortalUsersIdRoute
  BautagebuchIndexRoute: typeof BautagebuchIndexRoute
  PortalUsersIndexRoute: typeof PortalUsersIndexRoute
  SubunternehmerIndexRoute: typeof SubunternehmerIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/zeiterfassung': {
      id: '/zeiterfassung'
      path: '/zeiterfassung'
      fullPath: '/zeiterfassung'
      preLoaderRoute: typeof ZeiterfassungRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vertraege': {
      id: '/vertraege'
      path: '/vertraege'
      fullPath: '/vertraege'
      preLoaderRoute: typeof VertraegeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/serienleistungen': {
      id: '/serienleistungen'
      path: '/serienleistungen'
      fullPath: '/serienleistungen'
      preLoaderRoute: typeof SerienleistungenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reklamationen': {
      id: '/reklamationen'
      path: '/reklamationen'
      fullPath: '/reklamationen'
      preLoaderRoute: typeof ReklamationenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rechnungen': {
      id: '/rechnungen'
      path: '/rechnungen'
      fullPath: '/rechnungen'
      preLoaderRoute: typeof RechnungenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projekte': {
      id: '/projekte'
      path: '/projekte'
      fullPath: '/projekte'
      preLoaderRoute: typeof ProjekteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/objekte': {
      id: '/objekte'
      path: '/objekte'
      fullPath: '/objekte'
      preLoaderRoute: typeof ObjekteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mitarbeiter': {
      id: '/mitarbeiter'
      path: '/mitarbeiter'
      fullPath: '/mitarbeiter'
      preLoaderRoute: typeof MitarbeiterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kunden': {
      id: '/kunden'
      path: '/kunden'
      fullPath: '/kunden'
      preLoaderRoute: typeof KundenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kontrollgaenge': {
      id: '/kontrollgaenge'
      path: '/kontrollgaenge'
      fullPath: '/kontrollgaenge'
      preLoaderRoute: typeof KontrollgaengeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kontakte': {
      id: '/kontakte'
      path: '/kontakte'
      fullPath: '/kontakte'
      preLoaderRoute: typeof KontakteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finanzen': {
      id: '/finanzen'
      path: '/finanzen'
      fullPath: '/finanzen'
      preLoaderRoute: typeof FinanzenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auftraege': {
      id: '/auftraege'
      path: '/auftraege'
      fullPath: '/auftraege'
      preLoaderRoute: typeof AuftraegeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artikel': {
      id: '/artikel'
      path: '/artikel'
      fullPath: '/artikel'
      preLoaderRoute: typeof ArtikelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/angebote': {
      id: '/angebote'
      path: '/angebote'
      fullPath: '/angebote'
      preLoaderRoute: typeof AngeboteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/zeiterfassung/': {
      id: '/zeiterfassung/'
      path: '/'
      fullPath: '/zeiterfassung/'
      preLoaderRoute: typeof ZeiterfassungIndexRouteImport
      parentRoute: typeof ZeiterfassungRoute
    }
    '/vertraege/': {
      id: '/vertraege/'
      path: '/'
      fullPath: '/vertraege/'
      preLoaderRoute: typeof VertraegeIndexRouteImport
      parentRoute: typeof VertraegeRoute
    }
    '/subunternehmer/': {
      id: '/subunternehmer/'
      path: '/subunternehmer'
      fullPath: '/subunternehmer/'
      preLoaderRoute: typeof SubunternehmerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/serienleistungen/': {
      id: '/serienleistungen/'
      path: '/'
      fullPath: '/serienleistungen/'
      preLoaderRoute: typeof SerienleistungenIndexRouteImport
      parentRoute: typeof SerienleistungenRoute
    }
    '/reklamationen/': {
      id: '/reklamationen/'
      path: '/'
      fullPath: '/reklamationen/'
      preLoaderRoute: typeof ReklamationenIndexRouteImport
      parentRoute: typeof ReklamationenRoute
    }
    '/rechnungen/': {
      id: '/rechnungen/'
      path: '/'
      fullPath: '/rechnungen/'
      preLoaderRoute: typeof RechnungenIndexRouteImport
      parentRoute: typeof RechnungenRoute
    }
    '/projekte/': {
      id: '/projekte/'
      path: '/'
      fullPath: '/projekte/'
      preLoaderRoute: typeof ProjekteIndexRouteImport
      parentRoute: typeof ProjekteRoute
    }
    '/portal-users/': {
      id: '/portal-users/'
      path: '/portal-users'
      fullPath: '/portal-users/'
      preLoaderRoute: typeof PortalUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/objekte/': {
      id: '/objekte/'
      path: '/'
      fullPath: '/objekte/'
      preLoaderRoute: typeof ObjekteIndexRouteImport
      parentRoute: typeof ObjekteRoute
    }
    '/mitarbeiter/': {
      id: '/mitarbeiter/'
      path: '/'
      fullPath: '/mitarbeiter/'
      preLoaderRoute: typeof MitarbeiterIndexRouteImport
      parentRoute: typeof MitarbeiterRoute
    }
    '/kunden/': {
      id: '/kunden/'
      path: '/'
      fullPath: '/kunden/'
      preLoaderRoute: typeof KundenIndexRouteImport
      parentRoute: typeof KundenRoute
    }
    '/kontrollgaenge/': {
      id: '/kontrollgaenge/'
      path: '/'
      fullPath: '/kontrollgaenge/'
      preLoaderRoute: typeof KontrollgaengeIndexRouteImport
      parentRoute: typeof KontrollgaengeRoute
    }
    '/inbox/': {
      id: '/inbox/'
      path: '/'
      fullPath: '/inbox/'
      preLoaderRoute: typeof InboxIndexRouteImport
      parentRoute: typeof InboxRoute
    }
    '/bautagebuch/': {
      id: '/bautagebuch/'
      path: '/bautagebuch'
      fullPath: '/bautagebuch/'
      preLoaderRoute: typeof BautagebuchIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auftraege/': {
      id: '/auftraege/'
      path: '/'
      fullPath: '/auftraege/'
      preLoaderRoute: typeof AuftraegeIndexRouteImport
      parentRoute: typeof AuftraegeRoute
    }
    '/artikel/': {
      id: '/artikel/'
      path: '/'
      fullPath: '/artikel/'
      preLoaderRoute: typeof ArtikelIndexRouteImport
      parentRoute: typeof ArtikelRoute
    }
    '/angebote/': {
      id: '/angebote/'
      path: '/'
      fullPath: '/angebote/'
      preLoaderRoute: typeof AngeboteIndexRouteImport
      parentRoute: typeof AngeboteRoute
    }
    '/zeiterfassung/monat': {
      id: '/zeiterfassung/monat'
      path: '/monat'
      fullPath: '/zeiterfassung/monat'
      preLoaderRoute: typeof ZeiterfassungMonatRouteImport
      parentRoute: typeof ZeiterfassungRoute
    }
    '/zeiterfassung/antrag': {
      id: '/zeiterfassung/antrag'
      path: '/antrag'
      fullPath: '/zeiterfassung/antrag'
      preLoaderRoute: typeof ZeiterfassungAntragRouteImport
      parentRoute: typeof ZeiterfassungRoute
    }
    '/zeiterfassung/admin': {
      id: '/zeiterfassung/admin'
      path: '/admin'
      fullPath: '/zeiterfassung/admin'
      preLoaderRoute: typeof ZeiterfassungAdminRouteImport
      parentRoute: typeof ZeiterfassungRoute
    }
    '/vertraege/neu': {
      id: '/vertraege/neu'
      path: '/neu'
      fullPath: '/vertraege/neu'
      preLoaderRoute: typeof VertraegeNeuRouteImport
      parentRoute: typeof VertraegeRoute
    }
    '/vertraege/mahnungen': {
      id: '/vertraege/mahnungen'
      path: '/mahnungen'
      fullPath: '/vertraege/mahnungen'
      preLoaderRoute: typeof VertraegeMahnungenRouteImport
      parentRoute: typeof VertraegeRoute
    }
    '/serienleistungen/neu': {
      id: '/serienleistungen/neu'
      path: '/neu'
      fullPath: '/serienleistungen/neu'
      preLoaderRoute: typeof SerienleistungenNeuRouteImport
      parentRoute: typeof SerienleistungenRoute
    }
    '/serienleistungen/$id': {
      id: '/serienleistungen/$id'
      path: '/$id'
      fullPath: '/serienleistungen/$id'
      preLoaderRoute: typeof SerienleistungenIdRouteImport
      parentRoute: typeof SerienleistungenRoute
    }
    '/reklamationen/neu': {
      id: '/reklamationen/neu'
      path: '/neu'
      fullPath: '/reklamationen/neu'
      preLoaderRoute: typeof ReklamationenNeuRouteImport
      parentRoute: typeof ReklamationenRoute
    }
    '/reklamationen/$id': {
      id: '/reklamationen/$id'
      path: '/$id'
      fullPath: '/reklamationen/$id'
      preLoaderRoute: typeof ReklamationenIdRouteImport
      parentRoute: typeof ReklamationenRoute
    }
    '/rechnungen/neu': {
      id: '/rechnungen/neu'
      path: '/neu'
      fullPath: '/rechnungen/neu'
      preLoaderRoute: typeof RechnungenNeuRouteImport
      parentRoute: typeof RechnungenRoute
    }
    '/rechnungen/$id': {
      id: '/rechnungen/$id'
      path: '/$id'
      fullPath: '/rechnungen/$id'
      preLoaderRoute: typeof RechnungenIdRouteImport
      parentRoute: typeof RechnungenRoute
    }
    '/projekte/neu': {
      id: '/projekte/neu'
      path: '/neu'
      fullPath: '/projekte/neu'
      preLoaderRoute: typeof ProjekteNeuRouteImport
      parentRoute: typeof ProjekteRoute
    }
    '/projekte/$id': {
      id: '/projekte/$id'
      path: '/$id'
      fullPath: '/projekte/$id'
      preLoaderRoute: typeof ProjekteIdRouteImport
      parentRoute: typeof ProjekteRoute
    }
    '/portal-users/$id': {
      id: '/portal-users/$id'
      path: '/portal-users/$id'
      fullPath: '/portal-users/$id'
      preLoaderRoute: typeof PortalUsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/objekte/$id': {
      id: '/objekte/$id'
      path: '/$id'
      fullPath: '/objekte/$id'
      preLoaderRoute: typeof ObjekteIdRouteImport
      parentRoute: typeof ObjekteRoute
    }
    '/mitarbeiter/$id': {
      id: '/mitarbeiter/$id'
      path: '/$id'
      fullPath: '/mitarbeiter/$id'
      preLoaderRoute: typeof MitarbeiterIdRouteImport
      parentRoute: typeof MitarbeiterRoute
    }
    '/kunden/neu': {
      id: '/kunden/neu'
      path: '/neu'
      fullPath: '/kunden/neu'
      preLoaderRoute: typeof KundenNeuRouteImport
      parentRoute: typeof KundenRoute
    }
    '/kunden/$id': {
      id: '/kunden/$id'
      path: '/$id'
      fullPath: '/kunden/$id'
      preLoaderRoute: typeof KundenIdRouteImport
      parentRoute: typeof KundenRoute
    }
    '/kontrollgaenge/neu': {
      id: '/kontrollgaenge/neu'
      path: '/neu'
      fullPath: '/kontrollgaenge/neu'
      preLoaderRoute: typeof KontrollgaengeNeuRouteImport
      parentRoute: typeof KontrollgaengeRoute
    }
    '/kontrollgaenge/$id': {
      id: '/kontrollgaenge/$id'
      path: '/$id'
      fullPath: '/kontrollgaenge/$id'
      preLoaderRoute: typeof KontrollgaengeIdRouteImport
      parentRoute: typeof KontrollgaengeRoute
    }
    '/inbox/neu': {
      id: '/inbox/neu'
      path: '/neu'
      fullPath: '/inbox/neu'
      preLoaderRoute: typeof InboxNeuRouteImport
      parentRoute: typeof InboxRoute
    }
    '/inbox/$id': {
      id: '/inbox/$id'
      path: '/$id'
      fullPath: '/inbox/$id'
      preLoaderRoute: typeof InboxIdRouteImport
      parentRoute: typeof InboxRoute
    }
    '/finanzen/eingangsrechnungen': {
      id: '/finanzen/eingangsrechnungen'
      path: '/eingangsrechnungen'
      fullPath: '/finanzen/eingangsrechnungen'
      preLoaderRoute: typeof FinanzenEingangsrechnungenRouteImport
      parentRoute: typeof FinanzenRoute
    }
    '/finanzen/bank': {
      id: '/finanzen/bank'
      path: '/bank'
      fullPath: '/finanzen/bank'
      preLoaderRoute: typeof FinanzenBankRouteImport
      parentRoute: typeof FinanzenRoute
    }
    '/auftraege/offene-entscheidungen': {
      id: '/auftraege/offene-entscheidungen'
      path: '/offene-entscheidungen'
      fullPath: '/auftraege/offene-entscheidungen'
      preLoaderRoute: typeof AuftraegeOffeneEntscheidungenRouteImport
      parentRoute: typeof AuftraegeRoute
    }
    '/auftraege/neu': {
      id: '/auftraege/neu'
      path: '/neu'
      fullPath: '/auftraege/neu'
      preLoaderRoute: typeof AuftraegeNeuRouteImport
      parentRoute: typeof AuftraegeRoute
    }
    '/auftraege/$id': {
      id: '/auftraege/$id'
      path: '/$id'
      fullPath: '/auftraege/$id'
      preLoaderRoute: typeof AuftraegeIdRouteImport
      parentRoute: typeof AuftraegeRoute
    }
    '/artikel/$id': {
      id: '/artikel/$id'
      path: '/$id'
      fullPath: '/artikel/$id'
      preLoaderRoute: typeof ArtikelIdRouteImport
      parentRoute: typeof ArtikelRoute
    }
    '/angebote/neu': {
      id: '/angebote/neu'
      path: '/neu'
      fullPath: '/angebote/neu'
      preLoaderRoute: typeof AngeboteNeuRouteImport
      parentRoute: typeof AngeboteRoute
    }
    '/angebote/$id': {
      id: '/angebote/$id'
      path: '/$id'
      fullPath: '/angebote/$id'
      preLoaderRoute: typeof AngeboteIdRouteImport
      parentRoute: typeof AngeboteRoute
    }
    '/vertraege/neu_/vorlagen': {
      id: '/vertraege/neu_/vorlagen'
      path: '/neu/vorlagen'
      fullPath: '/vertraege/neu/vorlagen'
      preLoaderRoute: typeof VertraegeNeuVorlagenRouteImport
      parentRoute: typeof VertraegeRoute
    }
    '/vertraege/entwurf/$id': {
      id: '/vertraege/entwurf/$id'
      path: '/entwurf/$id'
      fullPath: '/vertraege/entwurf/$id'
      preLoaderRoute: typeof VertraegeEntwurfIdRouteImport
      parentRoute: typeof VertraegeRoute
    }
    '/vertraege/bv/$id': {
      id: '/vertraege/bv/$id'
      path: '/bv/$id'
      fullPath: '/vertraege/bv/$id'
      preLoaderRoute: typeof VertraegeBvIdRouteImport
      parentRoute: typeof VertraegeRoute
    }
  }
}

interface AngeboteRouteChildren {
  AngeboteIdRoute: typeof AngeboteIdRoute
  AngeboteNeuRoute: typeof AngeboteNeuRoute
  AngeboteIndexRoute: typeof AngeboteIndexRoute
}

const AngeboteRouteChildren: AngeboteRouteChildren = {
  AngeboteIdRoute: AngeboteIdRoute,
  AngeboteNeuRoute: AngeboteNeuRoute,
  AngeboteIndexRoute: AngeboteIndexRoute,
}

const AngeboteRouteWithChildren = AngeboteRoute._addFileChildren(
  AngeboteRouteChildren,
)

interface ArtikelRouteChildren {
  ArtikelIdRoute: typeof ArtikelIdRoute
  ArtikelIndexRoute: typeof ArtikelIndexRoute
}

const ArtikelRouteChildren: ArtikelRouteChildren = {
  ArtikelIdRoute: ArtikelIdRoute,
  ArtikelIndexRoute: ArtikelIndexRoute,
}

const ArtikelRouteWithChildren =
  ArtikelRoute._addFileChildren(ArtikelRouteChildren)

interface AuftraegeRouteChildren {
  AuftraegeIdRoute: typeof AuftraegeIdRoute
  AuftraegeNeuRoute: typeof AuftraegeNeuRoute
  AuftraegeOffeneEntscheidungenRoute: typeof AuftraegeOffeneEntscheidungenRoute
  AuftraegeIndexRoute: typeof AuftraegeIndexRoute
}

const AuftraegeRouteChildren: AuftraegeRouteChildren = {
  AuftraegeIdRoute: AuftraegeIdRoute,
  AuftraegeNeuRoute: AuftraegeNeuRoute,
  AuftraegeOffeneEntscheidungenRoute: AuftraegeOffeneEntscheidungenRoute,
  AuftraegeIndexRoute: AuftraegeIndexRoute,
}

const AuftraegeRouteWithChildren = AuftraegeRoute._addFileChildren(
  AuftraegeRouteChildren,
)

interface FinanzenRouteChildren {
  FinanzenBankRoute: typeof FinanzenBankRoute
  FinanzenEingangsrechnungenRoute: typeof FinanzenEingangsrechnungenRoute
}

const FinanzenRouteChildren: FinanzenRouteChildren = {
  FinanzenBankRoute: FinanzenBankRoute,
  FinanzenEingangsrechnungenRoute: FinanzenEingangsrechnungenRoute,
}

const FinanzenRouteWithChildren = FinanzenRoute._addFileChildren(
  FinanzenRouteChildren,
)

interface InboxRouteChildren {
  InboxIdRoute: typeof InboxIdRoute
  InboxNeuRoute: typeof InboxNeuRoute
  InboxIndexRoute: typeof InboxIndexRoute
}

const InboxRouteChildren: InboxRouteChildren = {
  InboxIdRoute: InboxIdRoute,
  InboxNeuRoute: InboxNeuRoute,
  InboxIndexRoute: InboxIndexRoute,
}

const InboxRouteWithChildren = InboxRoute._addFileChildren(InboxRouteChildren)

interface KontrollgaengeRouteChildren {
  KontrollgaengeIdRoute: typeof KontrollgaengeIdRoute
  KontrollgaengeNeuRoute: typeof KontrollgaengeNeuRoute
  KontrollgaengeIndexRoute: typeof KontrollgaengeIndexRoute
}

const KontrollgaengeRouteChildren: KontrollgaengeRouteChildren = {
  KontrollgaengeIdRoute: KontrollgaengeIdRoute,
  KontrollgaengeNeuRoute: KontrollgaengeNeuRoute,
  KontrollgaengeIndexRoute: KontrollgaengeIndexRoute,
}

const KontrollgaengeRouteWithChildren = KontrollgaengeRoute._addFileChildren(
  KontrollgaengeRouteChildren,
)

interface KundenRouteChildren {
  KundenIdRoute: typeof KundenIdRoute
  KundenNeuRoute: typeof KundenNeuRoute
  KundenIndexRoute: typeof KundenIndexRoute
}

const KundenRouteChildren: KundenRouteChildren = {
  KundenIdRoute: KundenIdRoute,
  KundenNeuRoute: KundenNeuRoute,
  KundenIndexRoute: KundenIndexRoute,
}

const KundenRouteWithChildren =
  KundenRoute._addFileChildren(KundenRouteChildren)

interface MitarbeiterRouteChildren {
  MitarbeiterIdRoute: typeof MitarbeiterIdRoute
  MitarbeiterIndexRoute: typeof MitarbeiterIndexRoute
}

const MitarbeiterRouteChildren: MitarbeiterRouteChildren = {
  MitarbeiterIdRoute: MitarbeiterIdRoute,
  MitarbeiterIndexRoute: MitarbeiterIndexRoute,
}

const MitarbeiterRouteWithChildren = MitarbeiterRoute._addFileChildren(
  MitarbeiterRouteChildren,
)

interface ObjekteRouteChildren {
  ObjekteIdRoute: typeof ObjekteIdRoute
  ObjekteIndexRoute: typeof ObjekteIndexRoute
}

const ObjekteRouteChildren: ObjekteRouteChildren = {
  ObjekteIdRoute: ObjekteIdRoute,
  ObjekteIndexRoute: ObjekteIndexRoute,
}

const ObjekteRouteWithChildren =
  ObjekteRoute._addFileChildren(ObjekteRouteChildren)

interface ProjekteRouteChildren {
  ProjekteIdRoute: typeof ProjekteIdRoute
  ProjekteNeuRoute: typeof ProjekteNeuRoute
  ProjekteIndexRoute: typeof ProjekteIndexRoute
}

const ProjekteRouteChildren: ProjekteRouteChildren = {
  ProjekteIdRoute: ProjekteIdRoute,
  ProjekteNeuRoute: ProjekteNeuRoute,
  ProjekteIndexRoute: ProjekteIndexRoute,
}

const ProjekteRouteWithChildren = ProjekteRoute._addFileChildren(
  ProjekteRouteChildren,
)

interface RechnungenRouteChildren {
  RechnungenIdRoute: typeof RechnungenIdRoute
  RechnungenNeuRoute: typeof RechnungenNeuRoute
  RechnungenIndexRoute: typeof RechnungenIndexRoute
}

const RechnungenRouteChildren: RechnungenRouteChildren = {
  RechnungenIdRoute: RechnungenIdRoute,
  RechnungenNeuRoute: RechnungenNeuRoute,
  RechnungenIndexRoute: RechnungenIndexRoute,
}

const RechnungenRouteWithChildren = RechnungenRoute._addFileChildren(
  RechnungenRouteChildren,
)

interface ReklamationenRouteChildren {
  ReklamationenIdRoute: typeof ReklamationenIdRoute
  ReklamationenNeuRoute: typeof ReklamationenNeuRoute
  ReklamationenIndexRoute: typeof ReklamationenIndexRoute
}

const ReklamationenRouteChildren: ReklamationenRouteChildren = {
  ReklamationenIdRoute: ReklamationenIdRoute,
  ReklamationenNeuRoute: ReklamationenNeuRoute,
  ReklamationenIndexRoute: ReklamationenIndexRoute,
}

const ReklamationenRouteWithChildren = ReklamationenRoute._addFileChildren(
  ReklamationenRouteChildren,
)

interface SerienleistungenRouteChildren {
  SerienleistungenIdRoute: typeof SerienleistungenIdRoute
  SerienleistungenNeuRoute: typeof SerienleistungenNeuRoute
  SerienleistungenIndexRoute: typeof SerienleistungenIndexRoute
}

const SerienleistungenRouteChildren: SerienleistungenRouteChildren = {
  SerienleistungenIdRoute: SerienleistungenIdRoute,
  SerienleistungenNeuRoute: SerienleistungenNeuRoute,
  SerienleistungenIndexRoute: SerienleistungenIndexRoute,
}

const SerienleistungenRouteWithChildren =
  SerienleistungenRoute._addFileChildren(SerienleistungenRouteChildren)

interface VertraegeRouteChildren {
  VertraegeMahnungenRoute: typeof VertraegeMahnungenRoute
  VertraegeNeuRoute: typeof VertraegeNeuRoute
  VertraegeIndexRoute: typeof VertraegeIndexRoute
  VertraegeBvIdRoute: typeof VertraegeBvIdRoute
  VertraegeEntwurfIdRoute: typeof VertraegeEntwurfIdRoute
  VertraegeNeuVorlagenRoute: typeof VertraegeNeuVorlagenRoute
}

const VertraegeRouteChildren: VertraegeRouteChildren = {
  VertraegeMahnungenRoute: VertraegeMahnungenRoute,
  VertraegeNeuRoute: VertraegeNeuRoute,
  VertraegeIndexRoute: VertraegeIndexRoute,
  VertraegeBvIdRoute: VertraegeBvIdRoute,
  VertraegeEntwurfIdRoute: VertraegeEntwurfIdRoute,
  VertraegeNeuVorlagenRoute: VertraegeNeuVorlagenRoute,
}

const VertraegeRouteWithChildren = VertraegeRoute._addFileChildren(
  VertraegeRouteChildren,
)

interface ZeiterfassungRouteChildren {
  ZeiterfassungAdminRoute: typeof ZeiterfassungAdminRoute
  ZeiterfassungAntragRoute: typeof ZeiterfassungAntragRoute
  ZeiterfassungMonatRoute: typeof ZeiterfassungMonatRoute
  ZeiterfassungIndexRoute: typeof ZeiterfassungIndexRoute
}

const ZeiterfassungRouteChildren: ZeiterfassungRouteChildren = {
  ZeiterfassungAdminRoute: ZeiterfassungAdminRoute,
  ZeiterfassungAntragRoute: ZeiterfassungAntragRoute,
  ZeiterfassungMonatRoute: ZeiterfassungMonatRoute,
  ZeiterfassungIndexRoute: ZeiterfassungIndexRoute,
}

const ZeiterfassungRouteWithChildren = ZeiterfassungRoute._addFileChildren(
  ZeiterfassungRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AngeboteRoute: AngeboteRouteWithChildren,
  ArtikelRoute: ArtikelRouteWithChildren,
  AuftraegeRoute: AuftraegeRouteWithChildren,
  FinanzenRoute: FinanzenRouteWithChildren,
  InboxRoute: InboxRouteWithChildren,
  KontakteRoute: KontakteRoute,
  KontrollgaengeRoute: KontrollgaengeRouteWithChildren,
  KundenRoute: KundenRouteWithChildren,
  LoginRoute: LoginRoute,
  MitarbeiterRoute: MitarbeiterRouteWithChildren,
  ObjekteRoute: ObjekteRouteWithChildren,
  ProjekteRoute: ProjekteRouteWithChildren,
  RechnungenRoute: RechnungenRouteWithChildren,
  ReklamationenRoute: ReklamationenRouteWithChildren,
  SerienleistungenRoute: SerienleistungenRouteWithChildren,
  UsersRoute: UsersRoute,
  VertraegeRoute: VertraegeRouteWithChildren,
  ZeiterfassungRoute: ZeiterfassungRouteWithChildren,
  PortalUsersIdRoute: PortalUsersIdRoute,
  BautagebuchIndexRoute: BautagebuchIndexRoute,
  PortalUsersIndexRoute: PortalUsersIndexRoute,
  SubunternehmerIndexRoute: SubunternehmerIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
